module.exports = "/_next/static/images/kn-ad086c55274cc0390a08fad5ae414590.svg";